import { Form, Grid, TextField } from '@approvalmax/ui/src/components';
import { constants } from 'modules/common';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import { qaPrefix } from '../../QBooksCounterpartyCreationPopupContent.constants';
import { AddressFieldId } from '../../QBooksCounterpartyCreationPopupContent.types';
import { messages } from './AddressSection.messages';
import type { AddressSectionProps } from './AddressSection.types';

const { qBooksConstants } = constants;
const qa = bemFactory.qa(qaPrefix);

export const AddressSection: FC<AddressSectionProps> = memo((props) => {
    const { name } = props;

    return (
        <Form.Part>
            <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                <TextField
                    label={messages.street}
                    name={`${name}.${AddressFieldId.street}`}
                    qa={qa(`address-address-editor`)}
                    multiline
                    height={116}
                    placeholder={messages.streetAddressPlaceholder}
                    maxLength={qBooksConstants.ADDRESS_STREET_MAX_LENGTH}
                />

                <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                    <TextField
                        label={messages.cityTown}
                        name={`${name}.${AddressFieldId.city}`}
                        qa={qa('city-town')}
                        placeholder={messages.cityTownPlaceholder}
                        maxLength={qBooksConstants.ADDRESS_CITY_MAX_LENGTH}
                    />

                    <TextField
                        label={messages.countyStateProvince}
                        name={`${name}.${AddressFieldId.state}`}
                        qa={qa('county-state-province')}
                        placeholder={messages.countyStateProvincePlaceholder}
                        maxLength={qBooksConstants.ADDRESS_REGION_MAX_LENGTH}
                    />

                    <TextField
                        label={messages.postalCode}
                        name={`${name}.${AddressFieldId.postalCode}`}
                        qa={qa('postal-code')}
                        placeholder={messages.postalCodePlaceholder}
                        maxLength={qBooksConstants.ADDRESS_POSTCODE_MAX_LENGTH}
                    />

                    <TextField
                        label={messages.country}
                        name={`${name}.${AddressFieldId.country}`}
                        qa={qa('country')}
                        placeholder={messages.countyPlaceholder}
                        maxLength={qBooksConstants.ADDRESS_COUNTRY_MAX_LENGTH}
                    />
                </Grid>
            </Grid>
        </Form.Part>
    );
});

AddressSection.displayName = 'AddressSection';
